import { render, staticRenderFns } from "./courseware-medias-view.vue?vue&type=template&id=4ce7aa1c&"
import script from "./courseware-medias-view.vue?vue&type=script&lang=js&"
export * from "./courseware-medias-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports